import { useEffect } from 'react'
import { consumeHandoffToken } from 'utils/auth-helper'

// index.js normally consumes /handoff before React mounts. This route covers an
// in-app navigation to /handoff: it swaps the session the same way, then does a
// full load so AuthProvider verifies the handed-off token from scratch.
function Handoff() {
  useEffect(() => {
    const target = consumeHandoffToken() || '/'
    window.location.replace(target)
  }, [])
  return null
}

export default Handoff
